import type {
  ListNotificationsQuery,
  NotificationEmailGovernanceResponse,
  NotificationListResponse,
  NotificationPreferences,
  NotificationUnreadCountResponse,
  SetNotificationEmailGovernanceRequest,
  UpdateNotificationPreferencesRequest,
} from '@jema-manager/shared';
import { apiClient } from './api-client';

export const notificationsApi = {
  list: async (
    params?: ListNotificationsQuery & { includeArchived?: boolean }
  ): Promise<NotificationListResponse> =>
    apiClient.get<NotificationListResponse>('/notifications', params),

  unreadCount: async (): Promise<NotificationUnreadCountResponse> =>
    apiClient.get<NotificationUnreadCountResponse>('/notifications/unread-count'),

  markAsRead: async (notificationId: string): Promise<{ item: any | null }> =>
    apiClient.patch<{ item: any | null }>(`/notifications/${notificationId}/read`),

  markAllAsRead: async (): Promise<{ updated: number }> =>
    apiClient.post<{ updated: number }>('/notifications/mark-all-read'),

  archive: async (notificationId: string): Promise<{ item: any | null }> =>
    apiClient.delete<{ item: any | null }>(`/notifications/${notificationId}`),

  getPreferences: async (): Promise<NotificationPreferences> =>
    apiClient.get<NotificationPreferences>('/notifications/preferences'),

  updatePreferences: async (
    payload: UpdateNotificationPreferencesRequest
  ): Promise<NotificationPreferences> =>
    apiClient.patch<NotificationPreferences>('/notifications/preferences', payload),

  getGovernance: async (userId: string): Promise<NotificationEmailGovernanceResponse> =>
    apiClient.get<NotificationEmailGovernanceResponse>(`/notifications/governance/users/${userId}`),

  setGovernance: async (
    userId: string,
    payload: SetNotificationEmailGovernanceRequest
  ): Promise<NotificationEmailGovernanceResponse> =>
    apiClient.put<NotificationEmailGovernanceResponse>(
      `/notifications/governance/users/${userId}`,
      payload
    ),
};
